function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
import dhtmlxHook from "./dhtmlx_hook";
dhtmlxHook();
import global from "./global";
import factoryMethod from "./scheduler_factory_method";
import ExtensionsManager from "./ext/extension_manager";
var SchedulerFactory = /*#__PURE__*/function () {
  function SchedulerFactory(extensions) {
    _classCallCheck(this, SchedulerFactory);
    this._seed = 0;
    this._schedulerPlugins = [];
    this._bundledExtensions = extensions;
    this._extensionsManager = new ExtensionsManager(extensions);
  }
  _createClass(SchedulerFactory, [{
    key: "plugin",
    value: function plugin(code) {
      this._schedulerPlugins.push(code);
      if (global.scheduler) {
        code(global.scheduler);
      }
    }
  }, {
    key: "getSchedulerInstance",
    value: function getSchedulerInstance(initConfig) {
      var scheduler = factoryMethod(this._extensionsManager);
      for (var i = 0; i < this._schedulerPlugins.length; i++) {
        this._schedulerPlugins[i](scheduler);
      }
      scheduler._internal_id = this._seed++;
      if (this.$syncFactory) {
        this.$syncFactory(scheduler);
      }
      if (initConfig) {
        this._initFromConfig(scheduler, initConfig);
      }
      return scheduler;
    }
  }, {
    key: "_initFromConfig",
    value: function _initFromConfig(scheduler, initConfig) {
      if (initConfig.plugins) {
        scheduler.plugins(initConfig.plugins);
      }
      if (initConfig.config) {
        scheduler.mixin(scheduler.config, initConfig.config, true);
      }
      if (initConfig.templates) {
        scheduler.attachEvent("onTemplatesReady", function () {
          scheduler.mixin(scheduler.templates, initConfig.templates, true);
        }, {
          once: true
        });
      }
      if (initConfig.events) {
        for (var event in initConfig.events) {
          scheduler.attachEvent(event, initConfig.events[event]);
        }
      }
      if (initConfig.locale) {
        scheduler.i18n.setLocale(initConfig.locale);
      }
      if (Array.isArray(initConfig.calendars)) {
        initConfig.calendars.forEach(function (calendar) {
          scheduler.addCalendar(calendar);
        });
      }
      if (initConfig.container) {
        scheduler.init(initConfig.container);
      } else {
        scheduler.init();
      }
      if (initConfig.data) {
        if (typeof initConfig.data === "string") {
          scheduler.load(initConfig.data);
        } else {
          scheduler.parse(initConfig.data);
        }
      }
    }
  }]);
  return SchedulerFactory;
}();
export default SchedulerFactory;